<template>
  <Page route-path="/archives.html">
    <div class="body">
      <div class="archives-head">
        <div class="banner-container">
          <img v-if="isNormal" class="backgroud-image" src="@/assets/archives/archives_banner.png" />
          <img v-else class="backgroud-image" src="@/assets/mobile/archives/archives-banner.svg" />
        </div>
        <div class="head-content">
          <div class="image-title">四库档案管理系统</div>
          <div class="text"><span>新一代数字化、生态化档案管理系统</span><span>100%归档、3秒检索、防篡改、用区块链第三方存证</span></div>
          <!-- <el-button >免费试用</el-button> -->
        </div>
      </div>
      <div class="archives-intro-container">
        <div class="archives-introduction">
          <span class="intro-header"> 四库档案 </span>
          <span class="intro-content">
            涵盖纸质档案和电子档案的全生命周期管理。<br />
            面向电子档案收集、生成、归档、借阅、统计、利用、鉴定、销毁的全过程管理。<br />
            全业务100%归档，归档文件防篡改、秒级可查，支持区块链多方存证验真。<br />
          </span>
        </div>
      </div>
  
      <div class="archives-features">
        <div class="title">特色亮点</div>
        <div class="features-box">
          <div class="features-box-item">
            <div class="features-box-item-inner">
              <div>
                <img src="@/assets/archives/archives_features1.png" alt="" style="width: 30px; height: 30px" />
                <span>100%一键归档</span>
              </div>
              <div>基于零代码自动化数据采集，可多通道动态/实时将业务数据自动汇集和归档，实现对多种业务数据100%应收尽收、一键归档。</div>
            </div>
          </div>
          <div class="features-box-item">
            <div class="features-box-item-inner">
              <div>
                <img src="@/assets/archives/archives_features2.png" alt="" style="width: 30px; height: 30px" />
                <span>秒级检索，高效利用</span>
              </div>
              <div>
                基于大数据技术实现对收集和归档的业务档案自动进行关联索引，建立档案大数据搜索引擎与档案检索门户，提供在线、实时、多维和可控可审的查询借阅功能，促进对档案数据的高效利用。
              </div>
            </div>
          </div>
          <div class="features-box-item">
            <div class="features-box-item-inner">
              <div>
                <img src="@/assets/archives/archives_features3.png" alt="" style="width: 30px; height: 30px" />
                <span>安全防篡改</span>
              </div>
              <div>
                采用国家密码标准算法、数据指纹技术、电子签名技术和区块链技术等多种密码技术手段，可对档案数据、档案元数据、档案的原始业务来源数据等建立数据指纹、电子签名以及区块链存证，从源头开始对电子档案提供密码级高安全的可查、可溯、可验的能力，确保归档的电子档案满足国家标准的“四性检测”要求。
              </div>
            </div>
          </div>
          <div class="features-box-item">
            <div class="features-box-item-inner">
              <div>
                <img src="@/assets/archives/archives_features4.png" alt="" style="width: 30px; height: 30px" />
                <span>业档一体化</span>
              </div>
              <div>
                组织数据分离、数据分布存储、异地灾备，保证数据永久有效存储，实体纸质档案需要有专门的实物档案室，耗费人力物力财力的同时，存储还需要防火防潮，保存更是需要十分谨慎防丢失防损坏等
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <div class="pilot-units">
        <div class="title">国家试点验证</div>
        <div class="pilot-units-text">
          &emsp;&emsp; <span class="name">链聚信息科技</span>是全国第三批增值税电子发票电子化报销、入账、归档试点单位，采用自主研发的<span class="product-name"
            >“四库档案管理系统”</span
          >进行试点并通过验收。
          <a target="_blank" href="/articles/article-1.html" class="a-link"
            >了解详情
            <img src="@/assets/baseIcon/jiantou.png" alt="" style="width: 14px; height: 14px" />
          </a>
        </div>
        <el-timeline>
          <el-timeline-item hollow color="#409EFF">
            <div class="select-box2">
              <span>04</span>
              <span>月/2021</span>
              <!-- <span class="title_2">试点启动</span> -->
            </div>
            <div class="select-detail">
              <div>试点启动</div>
              <div>2021年4月，链聚信息科技入选为国家第三批增值税电子发票电子化报销、入账、归档试点单位。</div>
              <div style="display: flex; align-items: center; justify-content: center">
                <div class="detail-content">
                  <div>
                    <img src="@/assets/archives/notice1.png" alt="" />
                    <img src="@/assets/archives/notice2.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </el-timeline-item>
          <el-timeline-item color="#409EFF">
            <div class="select-box2">
              <span>11</span>
              <span>月/2021</span>
            </div>
            <div class="select-detail">
              <div>验收通过</div>
              <div>
                2021年11月，湖南省档案局、财政厅、商务厅、国税总局湖南省税务局联合组织进行试点验收。湖南链聚信息科技基于自主研发的<span class="product-name"
                  >“四库档案管理系统”</span
                >进行的试点方案和取得的试点结果，得到领导和专家的一致肯定，顺利通过试点验收。
              </div>
              <div style="display: flex; align-items: center; justify-content: center">
                <div class="detail-content">
                  <div>
                    <img src="@/assets/archives/pass1.png" alt="" />
                    <img src="@/assets/archives/pass2.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </el-timeline-item>
          <el-timeline-item color="#409EFF">
            <div class="select-box2">
              <span>08</span>
              <span>月/2022</span>
            </div>
            <div class="select-detail2">
              <div class="title">全国试点总结</div>
              <div class="introduce">
                2022年8月26日，参加由国家档案局、税务总局、财务部、商务部联合召开的“增值税电子发票电子化报销、入账、归档试点工作总结会”。
                <div class="conference">
                  <img src="@/assets/archives/sumup1.png" alt="增值税电子发票电子化报销、入账、归档试点工作总结会——2022年8月26日" />
                </div>
              </div>
  
              <div class="doc-section">
                <span class="title">政策落地难点</span>
                <span class="content">
                  <ul>
                    <li>
                      <p>
                        电子会计档案管理全流程涉及的环节系统较多，电子数据本身天然具备的可复 制性，使得难以在各环节和系统之间确保档案数据的转移过程的真实性、完整
                        性、防篡改。
                      </p>
                    </li>
                    <li>
                      <p>难以在档案数据的创建、保管、移交、验真、查询、利用全过程环节中提供良 好的便利性以促进系统应用。</p>
                    </li>
                    <li>
                      <p>
                        同时各系统间也缺少统一的接口标准和数据模型，按照常规方法需要针对每一种系统每一套接口标准都需要重新开发与之相匹配的接口，导致研发成本的增加。
                      </p>
                    </li>
                  </ul>
                </span>
              </div>
              <div class="doc-section">
                <span class="title">我们的经验总结</span>
                <span class="content">
                  <ul>
                    <li>
                      <p>
                        基于我们自身在区块链底层核心技术产品的优势，利用区块链技术的防篡改、可追溯、分布式多方共识、安全可验证的特点，在密码级安全上保障了电子档案管理“真实、完整、可用、安全”四性要求。解决数字档案管理的安全问题。
                      </p>
                    </li>
                    <li>
                      <p>
                        基于<a href="/blockchain" target="_blank">“千尺区块链”</a
                        >的分布式账本之上，建立“四库档案数据链平台”，以数据总线模式形成了标准化的档案存证管理的数据结构与接口。
                      </p>
                    </li>
                    <li>
                      <p>
                        利用“四库档案数据链平台”形成的数据总线，实现数据交互的链上模式，使原来的网状定制对接模型转换为星形标准对接模型，基于 HTTP 协议
                        实现了标准化的 REST 服务接口，采用非关系文档数据库技术构建可处理海量数据的高性能档案存储。
                      </p>
                    </li>
                  </ul>
                </span>
              </div>
            </div>
          </el-timeline-item>
          <el-timeline-item color="#ffffff"></el-timeline-item>
        </el-timeline>
      </div>
  
      <div class="service-value">
        <div class="title">应用价值</div>
        <div class="value-box">
          <div class="value-box-item" v-for="(item, index) of valueBox" :key="index">
            <div class="value-box-item-title">
              <img :src="item.img" alt="" style="height: 36px; width: 36px; margin-right: 24px" />
              {{ item.title }}
            </div>
            <div class="value-box-item-text">
              {{ item.text }}
            </div>
          </div>
        </div>
      </div>
  
      <div class="advantage">
        <div class="title">我们的优势</div>
        <div class="advantage-content">
          <div class="advantage-content-item">
            <img src="@/assets/archives/1.png" alt="" style="height: 64px; width: 64px" />
            <div class="advantage-content-item-title">大数据</div>
            <div class="advantage-content-item-text">海量业务数据采集归档</div>
          </div>
          <!-- <div class="advantage-content-item">
                      <img src="@/assets/archives/2.png" alt="" style="height: 64px;width: 64px;" />
                      <div class="advantage-content-item-title">低投入</div>
                      <div class="advantage-content-item-text">高效远程运维服务</div>
                  </div> -->
          <div class="advantage-content-item">
            <img src="@/assets/archives/3.png" alt="" style="height: 64px; width: 64px" />
            <div class="advantage-content-item-title">云地一体</div>
            <div class="advantage-content-item-text">一站式的云技术服务</div>
          </div>
          <div class="advantage-content-item">
            <img src="@/assets/archives/4.png" alt="" style="height: 64px; width: 64px" />
            <div class="advantage-content-item-title">易操作</div>
            <div class="advantage-content-item-text">多途径轻松存阅信息资源</div>
          </div>
          <div class="advantage-content-item">
            <img src="@/assets/archives/5.png" alt="" style="height: 64px; width: 64px" />
            <div class="advantage-content-item-title">高安全</div>
            <div class="advantage-content-item-text">秘密独享的云空间</div>
          </div>
          <div class="advantage-content-item">
            <img src="@/assets/archives/6.png" alt="" style="height: 64px; width: 64px" />
            <div class="advantage-content-item-title">免维护</div>
            <div class="advantage-content-item-text">24小时即时服务响应机制</div>
          </div>
          <div class="advantage-content-item">
            <img src="@/assets/archives/7.png" alt="" style="height: 64px; width: 64px" />
            <div class="advantage-content-item-title">易对接</div>
            <div class="advantage-content-item-text">元数据灵活定义 打破系统对接壁垒</div>
          </div>
        </div>
      </div>
  
      <!-- <div class="module6">
              <div class="module6-content">
                  <P style="font-size: 28px;font-weight: 500;color: #FFFFFF;letter-spacing: 10px;margin-bottom: 24px;">
                      引领中国企业进入智能财务云时代</P>
                  <el-button>立即免费试用</el-button>
              </div>
          </div> -->
    </div>
  </Page>
</template>
<script>

import { ResponsiveBase } from "../../layout/reponsive-base";

export default {
  name: "Archives",
  mixins: [ResponsiveBase],
  data() {
    return {
      chooseIndex: 1,
      valueBox: [
        {
          img: require("@/assets/archives/value1.png"),
          title: "流程优化,降本增效",
          text: "不断优化流程，减少重复工作，大幅降低人力的投入，减少场地的投入，提升工作效率，为企业降本增效",
        },
        {
          img: require("@/assets/archives/value2.png"),
          title: "融合业档系统",
          text: "整体规划财务、税务、资金、档案等流程，为企业税务筹划选择合规方案，企业根据自身的票税状况，加强内部管理，做好应对措施，从根源上实现降本增效",
        },
        {
          img: require("@/assets/archives/value3.png"),
          title: "精准定位，提升利用效率",
          text: "档案线上查询、借阅便捷，量身定制查询、借阅诉求，全面提升档案利用便捷性，提升利用效率；突破地域限制，实现全面档案共享",
        },
        {
          img: require("@/assets/archives/value4.png"),
          title: "推进办公无纸化",
          text: "逐步实现全流程无纸化办公，无纸化归档，减少耗材投入，节能减排",
        },
        {
          img: require("@/assets/archives/value5.png"),
          title: "迎接全电发票时代",
          text: "积极响应国家“全电发票”的政策，电子会计归档工作已写入中央文件，2025年将全面进入全电发票时代，早用总受益，运用信息化、智能化技术手段，推动管理模式向精细化发展",
        },
      ],
    };
  },
  created() {},
  inject: ["pageIndicator"],
  computed: {},

  mounted() {},

  methods: {
    choose(index) {
      this.chooseIndex = index;
    },
  },
};
</script>
<style lang="less" scoped>
a {
  color: inherit;
  font-size: inherit;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  font-style: italic;
}
a:hover {
  color: #2e64f3;
}
span {
  font-size: 16px;
  color: #040420;
  font-weight: 400;
  line-height: 30px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
}

.body {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0px;
  padding-top: 65px;
}

.archives-head {
  background-size: 100% 100%;
  height: 428px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .banner-container {
    position: absolute;
    top: 64px;
    width: 100%;
    height: 428px;

    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }

  .head-content {
    width: 100%;
    max-width: 1280px;
    z-index: 1000;
    margin: 0px 20px;
  }

  .head-content span {
    font-size: 20px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #040420;
    line-height: 30px;
  }

  .image-title {
    font-size: 58px;
    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
    font-weight: 500;
    color: #040420;
    line-height: 58px;
  }

  @media screen and (max-width: 850px) {
    .image-title {
      font-size: 30px;
    }
  }

  .text {
    font-size: 20px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #040420;
    line-height: 30px;
    margin-top: 30px;
    margin-bottom: 50px;
    display: flex;
    flex-direction: column;
    align-content: flex-start;
    align-items: flex-start;

    span {
      margin-top: 8px;

      @media screen and (max-width: 850px) {
        font-size: 14px;
        line-height: 20px;
      }
    }
  }

  .el-button {
    width: 140px;
    height: 48px;
    font-size: 18px;
    border: 1px solid #ffffff;
    color: #ffffff;
    background-color: #ffffff00;
    font-weight: 500;
  }

  .el-button:hover {
    color: #2e64f3;
    background-color: #ffffff;
  }
}

.backgroud-image {
  height: 100%;
  width: 100%;
  min-width: 1280px;
  object-fit: cover;
}

@media screen and(max-width: 850px) {
  .head-content > .text {
    max-width: 320px;
  }

  .backgroud-image {
    min-width: auto;
  }
}

.el-timeline {
  margin-top: 60px;
}

.archives-intro-container {
  width: 100%;
  height: 166px;
  padding: 0;
  position: relative;
}

.archives-introduction {
  background-image: url(../../assets/BlockChain/blockchain_2.png);
  max-width: 1280px;
  height: auto;
  padding: 56px;
  position: absolute;
  top: -20px;
  left: 0px;
  right: 0px;
  margin: 0px auto;
  z-index: 1000;
  background-color: #ffffff;
  border: 4px solid #ffffff;
  box-shadow: 0px 0px 8px 1px rgba(0, 0, 0, 0.1);

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  column-gap: 90px;
  row-gap: 40px;
  flex-wrap: wrap;
}

.archives-introduction .intro-header {
  font-size: 38px;
  font-weight: 500;
  min-width: 154px;

  @media screen and (max-width: 850px) {
    font-size: 24px;
  }
}

.archives-introduction .intro-content {
  max-width: 920px;
  display: inherit;
  min-width: 340px;

  @media screen and (max-width: 850px) {
    font-size: 14px;
    line-height: 24px;
  }
}

.title {
  font-size: 36px;
  font-family: Source Han Sans CN-Medium, Source Han Sans CN;
  font-weight: 500;
  color: #040420;
  line-height: 72px;

  @media screen and (max-width: 850px) {
    font-size: 24px;
    line-height: 36px;
  }
}

.title_2 {
  font-size: 32px;
  font-family: Source Han Sans CN-Medium, Source Han Sans CN;
  font-weight: 500;
  color: #040420;
  line-height: 48px;
}

.title_3 {
  font-size: 24px;
  font-family: Source Han Sans CN-Medium, Source Han Sans CN;
  font-weight: 500;
  color: #040420;
  line-height: 48px;
}

.archives-features {
  padding-top: 150px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.features-box {
  width: 100%;
  padding-top: 62px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.features-box-item {
  min-width: 400px;
}

@media screen and (max-width: 850px) {
  .features-box-item {
    width: 100% !important;
    display: flex;
    justify-content: center !important;
  }
}

.features-box-item-inner {
  width: 100%;
  max-width: 610px;
  display: flex;
  flex-direction: column;
}

.features-box-item:nth-child(1) {
  padding: 30px 30px 30px 30px;
  width: 50%;
  border-top: 1px solid #efefef;
  border-right: 1px solid #efefef;
  border-bottom: 1px solid #efefef;
  display: flex;
  justify-content: flex-end;
}

.features-box-item:nth-child(3) {
  padding: 30px 30px 30px 30px;
  width: 50%;
  border-right: 1px solid #efefef;
  border-bottom: 1px solid #efefef;
  display: flex;
  justify-content: flex-end;
}

.features-box-item:nth-child(2) {
  padding: 30px 30px 30px 30px;
  width: 50%;
  border-top: 1px solid #efefef;
  border-bottom: 1px solid #efefef;
}

.features-box-item:nth-child(4) {
  padding: 30px 30px 30px 30px;
  width: 50%;
  border-bottom: 1px solid #efefef;
}

.features-box-item-inner div:first-child {
  display: flex;

  @media screen and (max-width: 850px) {
    align-items: center;
  }

  span {
    font-size: 24px;
    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
    font-weight: 500;
    color: #040420;
    line-height: 24px;
    margin-left: 24px;

    @media screen and (max-width: 850px) {
      font-size: 18px;
    }
  }
}

.features-box-item-inner div:last-child {
  font-size: 16px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #727272;
  line-height: 30px;
  margin-top: 36px;

  @media screen and (max-width: 850px) {
    font-size: 14px;
    line-height: 24px;
  }
}

.pilot-units {
  padding: 100px 30px 0px 30px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media screen and (max-width: 850px) {
    padding: 60px 15px 0px 15px;
  }
}

.a-link {
  font-size: 20px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #2e64f3;
  margin-left: 20px;

  @media screen and (max-width: 850px) {
    font-size: 14px;
  }
}

.pilot-units-text {
  max-width: 1280px;
  margin-top: 30px;
  font-size: 20px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #727272;
  line-height: 40px;
  padding: 0 30px;

  @media screen and (max-width: 850px) {
    font-size: 14px;
    line-height: 24px;
    padding: 0;
  }
}

.name {
  font-size: 24px;
  font-weight: 400;
  line-height: 24px;
  margin: 0 4px;

  @media screen and (max-width: 850px) {
    font-size: 16px;
    line-height: 16px;
  }
}

.product-name {
  font-size: inherit;
  font-weight: 500;
  line-height: 20px;
  margin: 0 4px;
  font-style: italic;
}

.pilot-units-content {
  padding: 60px 0px;
  width: 1280px;
  margin: 0 auto;
}

.select-box {
  width: 255px;
  height: 60px;
  background: linear-gradient(360deg, #f8f9fd 0%, #ffffff 100%);
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  border: 1px solid #e4e6ee;
  margin-right: 16px;
  display: flex;
  align-items: baseline;
  padding: 10px 0px 0px 10px;
  //border-radius: 7px;
  /*圆角弧度为7px*/
  position: relative;
}

.select-box2 {
  width: 255px;
  height: 60px;
  opacity: 1;
  margin-right: 16px;
  display: flex;
  //align-items: baseline;
  //border-radius: 7px;
  /*圆角弧度为7px*/
  position: relative;
}

.select-box2 span:first-child {
  height: 44px;
  font-size: 36px;
  font-family: DIN-Bold, DIN;
  font-weight: bold;
  color: #040420;
  line-height: 30px;

  @media screen and (max-width: 850px) {
    font-size: 22px;
  }
}

.select-box2 span:nth-child(2) {
  font-size: 24px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #040420;
  line-height: 30px;
  margin-left: 8px;
  margin-top: 3px;

  @media screen and (max-width: 850px) {
    font-size: 14px;
  }
}

.down {
  background: #2e64f3;
  border: 2px solid #2e64f3;

  &::before {
    content: "";
    width: 0;
    height: 0;
    border: 5px solid;
    position: absolute;
    bottom: -12px;
    left: 122px;
    border-color: #2e64f3 transparent transparent;
  }

  &::after {
    content: "";
    width: 0;
    height: 0;
    border: 5px solid;
    position: absolute;
    bottom: -12px;
    left: 122px;
    border-color: #2e64f3 transparent transparent;
  }
}

// .select-box::before {
//     content: '';
//     width: 0;
//     height: 0;
//     border: 5px solid;
//     position: absolute;
//     bottom: -12px;
//     left: 112px;
//     border-color: #2E64F3 transparent transparent;

// }

// .select-box::after {
//     content: '';
//     width: 0;
//     height: 0;
//     border: 5px solid;
//     position: absolute;
//     bottom: -12px;
//     left: 112px;
//     border-color: #2E64F3 transparent transparent;
// }
.select-box span:first-child {
  height: 44px;
  font-size: 36px;
  font-family: DIN-Bold, DIN;
  font-weight: bold;
  color: #727272;
  line-height: 30px;
}

.select-box span:nth-child(2) {
  height: 17px;
  font-size: 16px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #727272;
  line-height: 30px;
  margin-left: 8px;
}

.select-box span:last-child {
  height: 18px;
  font-size: 18px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #727272;
  line-height: 30px;
  margin-left: 10px;
}

.down span:first-child {
  height: 44px;
  font-size: 36px;
  font-family: DIN-Bold, DIN;
  font-weight: bold;
  color: #ffffff;
  line-height: 30px;
}

.down span:nth-child(2) {
  height: 17px;
  font-size: 16px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  line-height: 30px;
  margin-left: 8px;
}

.down span:last-child {
  height: 18px;
  font-size: 18px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  line-height: 30px;
  margin-left: 10px;
}

.select_tags {
  display: flex;
}

.select-detail {
  width: 100%;
  height: auto;
  background: linear-gradient(360deg, #f8f9fd 0%, #ffffff 100%);
  opacity: 1;
  border: 1px solid #e4e6ee;
  padding: 40px 60px 20px 60px;

  @media screen and (max-width: 850px) {
    padding: 24px 12px 20px 12px;
  }
}

.select-detail div:first-child {
  font-size: 32px;
  font-family: Source Han Sans CN-Medium, Source Han Sans CN;
  font-weight: 500;
  color: #040420;
  line-height: 32px;

  @media screen and (max-width: 850px) {
    font-size: 18px;
  }
}

.select-detail div:nth-child(2) {
  // height: 18px;
  font-size: 18px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #727272;
  line-height: 30px;
  margin: 32px 0px;

  @media screen and (max-width: 850px) {
    font-size: 14px;
    line-height: 24px;
  }
}

.detail-content {
  height: 100% !important;
  margin: 0px !important;
}

.detail-content div:first-child {
  text-align: center;
  width: 100%;
}

.detail-content div:last-child {
  text-align: center;
  width: 100%;
  margin-top: 20px;
  font-size: 16px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #727272;
  line-height: 30px;
}

.detail-content div {
  width: 100%;
  height: 100%;
}

.detail-content div img {
  width: 100%;
  height: 100%;
  max-width: 315px;
  max-height: 420px;
  object-fit: scale-down;
}

.select-detail2 {
  width: 100%;
  height: auto;
  background: linear-gradient(360deg, #f8f9fd 0%, #ffffff 100%);
  opacity: 1;
  border: 1px solid #e4e6ee;
  padding: 40px 32px 20px 32px;

  .introduce {
    font-size: 18px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #727272;
    line-height: 30px;
    margin-top: 32px;

    .conference {
      width: 100%;
      height: auto;
      margin-top: 8px;
    }

    .conference img {
      width: 100%;
      height: 100%;
      object-fit: scale-down;
    }

    @media screen and (max-width: 850px) {
      font-size: 14px;
      line-height: 24px;
      margin-top: 12px;
    }
  }

  .title {
    font-size: 32px;
    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
    font-weight: 500;
    line-height: 64px;
    color: #040420;

    @media screen and (max-width: 850px) {
      font-size: 18px;
    }
  }

  .foot-title {
    font-size: 24px;
    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
    font-weight: 500;
    color: #040420;
    line-height: 24px;
    margin-top: 24px;
    margin-bottom: 24px;
  }

  .foot-introduce {
    font-size: 18px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #727272;
    line-height: 30px;
  }

  @media screen and (max-width: 850px) {
    padding: 24px 12px 20px 12px;
  }
}

.doc-section {
  font-family: Source Han Sans CN-Medium, Source Han Sans CN;
  display: flex;
  flex-direction: column;

  .title {
    font-size: 24px;
    color: #040420;
    font-weight: 500;
    line-height: 48px;
    margin: 16px;

    @media screen and (max-width: 850px) {
      font-size: 18px;
      margin: 0px;
    }
  }

  .content {
    font-size: 18px;
    color: #727272;
    font-weight: 400;
    line-height: 32px;
  }

  .content ul {
    @media screen and (max-width: 850px) {
      padding-left: 12px;
    }
  }

  .content p {
    font-size: 18px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    color: #727272;
    font-weight: 400;
    margin-bottom: 16px;

    @media screen and (max-width: 850px) {
      font-size: 14px;
      line-height: 24px;
    }
  }
}
.doc-section .content p > a {
  font-weight: 500;
  margin: 0px 4px;
}

.select-detail2-center {
  display: flex;
  justify-content: space-between;

  .select-detail2-center-left {
    width: 640px;
  }

  .select-detail2-center-left div:first-child {
    font-size: 24px;
    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
    font-weight: 500;
    color: #040420;
    line-height: 24px;
    margin-top: 24px;
    margin-bottom: 20px;
  }

  .select-detail2-center-left div:last-child {
    font-size: 18px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #727272;
    line-height: 30px;
  }
}

.service-value {
  width: 100%;
  background: #f8f9fd;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 100px 0px 80px;

  .text {
    height: 20px;
    font-size: 20px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #727272;
    line-height: 30px;
    margin-top: 30px;
    margin-bottom: 46px;
  }

  .content {
    display: flex;
    flex-wrap: wrap;
    width: 1320px;
    justify-content: center;
    margin-top: 30px;

    .item {
      width: 408px;
      height: 396px;
      background: #ffffff;
      box-shadow: 0px 0px 8px 1px rgba(0, 0, 0, 0.1);
      border-radius: 12px 12px 12px 12px;
      opacity: 1;
      margin: 14px;
    }

    .item-foot {
      padding: 30px;
    }

    .item-foot-title {
      height: 24px;
      font-size: 24px;
      font-family: Source Han Sans CN-Medium, Source Han Sans CN;
      font-weight: 500;
      color: #040420;
      line-height: 24px;
    }

    .item-foot-text {
      height: 106px;
      font-size: 16px;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color: #727272;
      line-height: 30px;
      margin-top: 24px;
    }
  }
}

.advantage {
  width: 100%;
  background: #f8f9fd;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 100px 0px 0px 0px;
  background-color: #ffffff;

  .advantage-content {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 60px;
    width: 100%;
    max-width: 1280px;
    column-gap: 215px;

    .advantage-content-item {
      width: 26%;
      max-width: 280px;
      min-width: 220px;
      margin-bottom: 80px;
      text-align: center;

      .advantage-content-item-title {
        height: 24px;
        font-size: 24px;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        font-weight: 500;
        color: #040420;
        line-height: 24px;
        margin-top: 36px;
        margin-bottom: 20px;

        @media screen and (max-width: 850px) {
          font-size: 18px;
        }
      }

      .advantage-content-item-text {
        font-size: 18px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #727272;
        line-height: 30px;

        @media screen and (max-width: 850px) {
          font-size: 14px;
          line-height: 24px;
        }
      }
    }
  }

  @media screen and (max-width: 1260px) {
    .advantage-content {
      justify-content: center;
      column-gap: 28px;
    }
  }

  @media screen and (max-width: 850px) {
    .advantage-content {
      justify-content: center;
      column-gap: 28px;
    }

    padding: 0px 20px;
  }
}

.value-box {
  max-width: 1280px;
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  justify-content: space-between;
  row-gap: 28px;

  margin-top: 60px;

  .value-box-item {
    width: 408px;
    height: 256px;
    background: #ffffff;
    box-shadow: 0px 0px 8px 1px rgba(0, 0, 0, 0.1);
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    // margin-bottom: 28px;
    padding: 48px 36px;

    .value-box-item-title {
      font-size: 24px;
      font-family: Source Han Sans CN-Medium, Source Han Sans CN;
      font-weight: 500;
      color: #040420;
      line-height: 24px;
      margin-bottom: 18px;
      display: flex;
      align-items: center;

      @media screen and (max-width: 850px) {
        font-size: 18px;
      }
    }

    .value-box-item-text {
      font-size: 16px;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color: #727272;
      line-height: 30px;

      @media screen and (max-width: 850px) {
        font-size: 14px;
        line-height: 24px;
      }
    }
  }

  .value-box-item:last-child {
    width: 844px;
  }

  .value-box-item:hover {
    box-shadow: 0px 0px 15px 1px rgba(0, 0, 0, 0.2);
  }

  @media screen and (max-width: 1250px) {
    justify-content: center;
    column-gap: 28px;
  }

  @media screen and (max-width: 850px) {
    justify-content: center;
    column-gap: 28px;
    padding: 0px 20px;

    .value-box-item {
      width: 100%;
    }
  }
}

.module6 {
  background: url(../../assets/lowcode/module6.png) no-repeat center center;
  background-size: 100% 100%;
  height: 160px;
  width: 100%;

  .module6-content {
    padding: 34px 320px;

    .el-button {
      width: 168px;
      height: 40px;
      font-size: 20px;
      border: 1px solid #ffffff;
      color: #ffffff;
      background-color: #ffffff00;
      font-weight: 500;
    }

    .el-button:hover {
      color: #2e64f3;
      background-color: #ffffff;
    }
  }
}

:deep(.el-timeline) {
  width: 100%;
  max-width: 1226px;
  padding: 10px;

  @media screen and (max-width: 850px) {
    padding: 0px;
    margin-top: 30px;
  }
}

:deep(.el-timeline-item) {
  padding-bottom: 10px;
  box-sizing: border-box;
}

:deep(.el-timeline-item__wrapper) {
  @media screen and (max-width: 850px) {
    padding-left: 12px;
  }
}

:deep(.el-timeline-item .el-timeline-item__wrapper) {
  top: -10px;
}
</style>
